
<div class="alert alert-dismissible text-center cookiealert"  role="alert" [class.show]="show">
  <div class="cookiealert-container" style="    font-size: small;"> {{'TESTO_COOKIES' | translate | htmlToText}} <span [innerHTML]="'TESTO_LINK_COOKIES' | translate"></span>

    <button type="button" class="btn btn-stem btn-sm acceptcookies" aria-label="Close" (click)="chiudi($event)">
        {{'ACCETTA' | translate | htmlToText}}
    </button>
  </div>
</div>

